const _ = require("lodash");

export const getVariant = (state, campaignCode) => {
  return _.get(state, `rlab.variants.${campaignCode}`, "");
};

export const generatingVariants = state => {
  return _.get(state, "rlab.generating", false);
};
